import React from 'react';
import PropTypes from 'prop-types';
import { connectLean } from 'lean-redux';
import { connect } from 'react-redux';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';
import useAttestation from 'legacy/src/components/assessment/hooks/useAttestation';
import AssignItem from 'legacy/src/components/assessment/AssignItem';
import connectLeanUpdateAssignments from 'chameleon-src/utility/connectLeanUpdateAssignments';
import get from 'lodash/get';

const AssignButton = ({
  assignment,
  showAttestationConfirmationDialog,
  itemTitle,
  saveAssignedState,
  onItemAction = () => {},
  onAssignCallback,
  isSPP = false,
  isPPC = false,
  useNewAssignModalFlag,
  studentsBySection,
}) => {
  const { hasScrambleablePEs } = useAttestation({
    showAttestationFlag: showAttestationConfirmationDialog,
  });
  const {
    isSecure,
    scrambleQuestions,
    assessment: { id: assessmentId, isPracticeExam } = {},
  } = assignment || {};

  const onAssignItem = (assignmentsResponse, totalAssignees) => {
    if (useNewAssignModalFlag) {
      onAssignCallback(assignmentsResponse.assignments, itemTitle);
    } else {
      onAssignCallback(totalAssignees, itemTitle);
    }

    connectLeanUpdateAssignments({
      assignmentsResponse,
      totalAssignees,
      saveAssignedState,
      onItemAction,
      useNewAssignModalFlag,
      studentsBySection,
    });
  };
  return (
    <AssignItem
      isSPP={isSPP}
      isPPC={isPPC}
      selectedGroups={[]}
      groups={[]}
      itemId={Number.parseInt(assessmentId, 10)}
      itemTitle={itemTitle}
      hideSecureToggle={!isSecure}
      onAssign={onAssignItem}
      onAssignRedirect={false}
      scrambleable={scrambleQuestions || hasScrambleablePEs(isPracticeExam)}
      button={
        <ButtonWithIcon
          tabIndex={0}
          isPrimary
          icon="person_add"
          iconClassName="fill-current text-white"
          accessibility={{
            'aria-label': 'Assign Quiz',
          }}
        >
          Assign
        </ButtonWithIcon>
      }
    />
  );
};

AssignButton.defaultProps = {
  onAssignCallback: PropTypes.func,
  itemTitle: PropTypes.func.isRequired,
  useNewAssignModalFlag: PropTypes.bool,
};

AssignButton.defaultProps = {
  onAssignCallback: () => {},
  useNewAssignModalFlag: false,
};

const mapStateToProps = ({ featureFlag, studentsBySection }) => {
  return {
    useNewAssignModalFlag: featureFlag.new_assign_modal,
    studentsBySection,
  };
};

export default connectLean({
  saveAssignedState(updatedAssignmentsInfo, assignResponse) {
    const { assignmentOverview = {}, assignResponses = [] } = this.state;
    const assignments = get(assignmentOverview, 'assignments', []);

    this.setState({
      assignmentOverview: {
        ...assignmentOverview,
        assignments: [...assignments, ...updatedAssignmentsInfo],
      },
      assignResponses: [...assignResponses, ...assignResponse],
    });
  },
})(connect(mapStateToProps)(AssignButton));
